import { TRACKED_PRODUCT_STATUS_EXTRA, TRACKED_PRODUCT_STATUS_MISSING } from './../scan-rack/edit/edit.const';
import { FETCH_ALL_DESTINATION_REQUESTED } from './../../destination/destination.action';
import { GO_TO_DESTINATION, FILTER_FROM_STORAGE } from './storage.action';
import { SCAN_LOCATION_REQUESTED } from './../scan-rack/list/list.actions';
import { Component, OnInit, AfterViewChecked, OnDestroy } from '@angular/core';
import store from '../../../store/store.module';
import * as $ from 'jquery';
import * as _ from 'lodash';
import { ActivatedRoute, Router, NavigationEnd } from '@angular/router';
import { Subscription } from 'rxjs/Subscription';

@Component({
  selector: 'app-storage',
  templateUrl: './storage.component.html',
  styleUrls: ['./storage.component.scss']
})
export class StorageComponent implements OnInit, AfterViewChecked, OnDestroy {
  navigationSubscription: Subscription;
  public store = store;
  public SCAN_LOCATION_REQUESTED = SCAN_LOCATION_REQUESTED;
  public GO_TO_DESTINATION = GO_TO_DESTINATION;
  public FILTER_FROM_STORAGE = FILTER_FROM_STORAGE;
  public TRACKED_PRODUCT_STATUS_MISSING = TRACKED_PRODUCT_STATUS_MISSING;
  public TRACKED_PRODUCT_STATUS_EXTRA = TRACKED_PRODUCT_STATUS_EXTRA;

  public getMissingItem = location => {
    if (_.isUndefined(location.last_track)) {
      return [];
    }
    return _.filter(location.last_track.products, product => _.get(product, 'product_track.status') === TRACKED_PRODUCT_STATUS_MISSING);
    // tslint:disable-next-line:semicolon
  };

  public getExtraItem = location => {
    if (_.isUndefined(location.last_track)) {
      return [];
    }
    return _.filter(location.last_track.products, product => _.get(product, 'product_track.status') === TRACKED_PRODUCT_STATUS_EXTRA);
    // tslint:disable-next-line:semicolon
  };

  constructor(private activeRoute: ActivatedRoute, private route: Router) {
    this.navigationSubscription = this.route.events.subscribe((e: any) => {
      if (e instanceof NavigationEnd) {
        store.dispatch({ type: FETCH_ALL_DESTINATION_REQUESTED, com: 'STORAGE_COMPONENT' });
      }
    });
  }

  ngOnInit() {}
  ngOnDestroy() {
    if (!_.isUndefined(this.navigationSubscription)) {
      this.navigationSubscription.unsubscribe();
    }
  }
  ngAfterViewChecked() {}
}
